import { useAnalysisStore } from '@modules/analysis/store/analysisStore';

export const useIsAnalysisEditable = (): boolean => {
  const editToken = useAnalysisStore(({ editToken }) => editToken);
  return !!editToken;
};
